import React, { useCallback, useEffect, useState } from 'react';
import { AudioElement, ImageElement, VideoElement } from '@bynder-studio/render-core';
import useEditorSelectedElement from '~/hooks/useEditorSelectedElement';
import useEditor from '~/hooks/useEditor';
import PersonalUploadsBase from './PersonalUploadsBase';
import { createOnTogglePersonalUploads, isPersonalUploadsAllowed } from './utils';

const PersonalUploads = ({ disabled = false }) => {
    const { selectedElement } = useEditorSelectedElement<ImageElement | VideoElement | AudioElement>();
    const { creativeModel } = useEditor();
    const [isAllowed, setAllowed] = useState(isPersonalUploadsAllowed(selectedElement));

    const onToggle = useCallback(() => {
        createOnTogglePersonalUploads(creativeModel, selectedElement);
        setAllowed(isPersonalUploadsAllowed(selectedElement));
    }, [creativeModel, selectedElement]);

    useEffect(() => {
        setAllowed(isPersonalUploadsAllowed(selectedElement));
    }, [selectedElement?.virtualData?.allowPersonalUpload]);

    return (
        <PersonalUploadsBase isAllowed={isAllowed} onToggle={onToggle} disabled={selectedElement.locked || disabled} />
    );
};

export default PersonalUploads;
